<mat-horizontal-stepper linear #stepper class="add-new-lead-stepper">
  <mat-step>
    <div>
      <div class="tw-pt-4 tw-grid tw-grid-flow-col tw-justify-between tw-place-items-center" *ngIf="!callWrapUp">
        <h2 class="new-business-heading">Add New Business</h2>
        <button mat-icon-button mat-dialog-close>
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="tw-mb-3">
        <app-alert *ngIf="(showErrorMessage$ | async)"
          [message]="errMessage ? errMessage : 'Failed to create new lead'"
          level="error"
          (dismissed)="newBusinessAlertDismissed?.emit()">
        </app-alert>
      </div>

      <form [formGroup]="addBusinessForm" class="add-new-lead-form">
          <formly-form [options]='formOptions' [form]="addBusinessForm" [fields]="fields" [model]="model"></formly-form>
          <span><strong>* = Required fields</strong></span>
          <div *ngIf="isFranchise" class="bulk-import">
            <div>Want to do a bulk import of your businesses from a spreadsheet? Use our
              <a mat-dialog-close routerLink="/import">Bulk Import Tool</a>.
            </div>
          </div>
          <mat-dialog-actions align="end">
              <button mat-button mat-dialog-close>Cancel</button>
              <button
                *ngIf="!isClientReferral(); else clientReferral"
                color="primary"
                mat-raised-button
                matStepperNext
                data-cy="continueNewLead"
                [disabled]="!addBusinessForm.valid" type="submit">
                Continue
              </button>
              <ng-template #clientReferral>
                <button color="primary"
                  mat-raised-button
                  data-cy="submitReferralLead"
                  [disabled]="!addBusinessForm.valid || (loading$ | async)"
                  type="submit"
                  (click)="saveNewLead()">
                  <span *ngIf="!(loading$ | async)">Save Referral</span>
                  <mat-spinner
                    diameter="24"
                    style="display: inline-block; height: 24px; width: 24px"
                    *ngIf="(loading$ | async)">
                  </mat-spinner>
                </button>
              </ng-template>
            </mat-dialog-actions>
      </form>
    </div>
  </mat-step>
  <mat-step>
    <app-add-more-info-lead-form
      (saveData)="saveNewLead($event)"
      [loading$]="loading$"
      [showErrorMessage$]="showErrorMessage$"
      [errMessage]="errMessage">
    </app-add-more-info-lead-form>
  </mat-step>
</mat-horizontal-stepper>
